import React from 'react';
import MainParticipantInfo from './MainParticipantInfo';
import ParticipantTracks from './ParticipantTracks';
import useMainSpeaker from '../hooks/useMainSpeaker'; //import useSelectedParticipant from '../VideoProvider/useSelectedParticipant/useSelectedParticipant';

import useScreenShareParticipant from '../hooks/useScreenShareParticipant';
export default function MainParticipant(_ref) {
  var showOverlays = _ref.showOverlays;
  var mainParticipant = useMainSpeaker(); //const [selectedParticipant] = useSelectedParticipant();

  var screenShareParticipant = useScreenShareParticipant();
  var videoPriority = //mainParticipant === selectedParticipant || mainParticipant === screenShareParticipant ? 'high' : null;
  mainParticipant === screenShareParticipant ? 'high' : null;
  return /*#__PURE__*/React.createElement(MainParticipantInfo, {
    participant: mainParticipant,
    showOverlays: showOverlays
  }, /*#__PURE__*/React.createElement(ParticipantTracks, {
    participant: mainParticipant,
    enableScreenShare: true,
    videoPriority: videoPriority
  }));
}